import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { CButton } from '@coreui/react-pro'
import DragonController from '../../ProgressNote/DragonController'
import { performAiCodeCheck, refreshEncounter } from '../../../../redux/sidePanel/sidePanelThunk'
import FEATURES from '../../../../utils/featuresConstants'
import { setAiCodeCheckStatus, setTabIndexes } from '../../../../redux/sidePanel/sidePanelSlice'
import { getChartText } from '../../../../utils/sharedChartFunctions'
import { SIDE_PANEL_TAB_COL_INDEXES, SIDE_PANEL_TAB_ROW_INDEXES } from '../../sharedConstants'

export default function PanelDraftNoteButtons({ onSaveDraft, onSignAndBill }) {
  const dispatch = useDispatch()
  const panelEncounterId = useSelector((state) => state.sidePanel.panelEncounter?._id)

  const selectedSections = useSelector((state) => state.progressNote.selectedSections)

  const features = useSelector((state) => state.user.features)
  const canUseDragon = features?.includes(FEATURES.Dragon)

  const [isAICodeChecking, setIsAICodeChecking] = useState(false)

  const chartTextEmpty = !getChartText({ data: selectedSections })

  return (
    <div id={'PanelDraftNoteButtons'}>
      <CButton color="primary" size="sm" className="ms-2 " onClick={onSignAndBill}>
        Sign Note
      </CButton>

      {features?.includes(FEATURES.DesktopAI) && (
        <CButton
          color="primary"
          size="sm"
          className={`ms-2 ai-code-check ${chartTextEmpty ? 'disabled' : ''}`}
          disabled={chartTextEmpty}
          onClick={async () => {
            if (isAICodeChecking) {
              return
            }
            await onSaveDraft()
            setIsAICodeChecking(true)
            dispatch(setTabIndexes({ side: SIDE_PANEL_TAB_COL_INDEXES.MAIN }))
            dispatch(setTabIndexes({ top: SIDE_PANEL_TAB_ROW_INDEXES.DX }))
            dispatch(setAiCodeCheckStatus(true))

            // save note is delayed, so we must sadly respect that
            setTimeout(async () => {
              await dispatch(performAiCodeCheck())
              await dispatch(refreshEncounter({ encounterId: panelEncounterId, useAiCpt: true }))

              dispatch(setAiCodeCheckStatus(false))
              setIsAICodeChecking(false)
            }, 2000)
          }}
        >
          {isAICodeChecking ? (
            <i className="fa-duotone fa-solid fa-spinner-third fa-spin" title={'Thinking hard'}></i>
          ) : (
            'AI Code Check'
          )}
        </CButton>
      )}
      <CButton
        color="primary"
        size="sm"
        onClick={() => {
          onSaveDraft()
        }}
      >
        Save Note
      </CButton>
      <CButton
        color="primary"
        size="sm"
        onClick={() => {
          onSaveDraft(null, { isPendingReview: true })
        }}
      >
        Pending Review
      </CButton>

      {canUseDragon && <DragonController />}
    </div>
  )
}
